import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { JwtTokenService } from '../tokens/jwt.tokens';

@Injectable()
export class JwtInterceptor implements HttpInterceptor {
  constructor(
    private tokenInject: JwtTokenService
  ) {}

  intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    req = req.clone({
      setHeaders: {
        Authorization: `Bearer ${this.tokenInject.getJwtToken()}`,
      },
    });

    return next.handle(req);
  }
}
